import {Directive, HostListener, output} from '@angular/core';

@Directive({
  selector: '[appBuildNumber]',
  standalone: true,
})
export class BuildNumberDirective {
  readonly showDialog = output<boolean>();

  @HostListener('window:keyup', ['$event'])
  onKeyEvent(event: KeyboardEvent) {
    if (event.key == 'PrintScreen') {
      this.showDialog.emit(true);
    }
  }
}
